import script from "./tabButtonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./tabButtonGroup.vue?vue&type=script&setup=true&lang=js"

import "./tabButtonGroup.vue?vue&type=style&index=0&id=3c620124&lang=less&scoped=true"

import exportComponent from "D:\\workspaceJava\\wlyc\\wlyc\\tianjing-client-web-develop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c620124"]])

export default __exports__